import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable } from "hooks";
import moment from "moment";
import { useState } from "react";
import { Value } from "react-date-picker/dist/cjs/shared/types";
import { useParams } from "react-router-dom";

import { useGetDeliveriesByDriver } from "../apis";

const useDeliveriesByDriver = () => {
  const { driverId } = useParams();

  const {
    searchValue,
    debouncedSearch,
    setSearchValue,
    page,
    setPage,
    sorting,
    setSorting
  } = useManageTable({ defaultSorting: [{ id: "DeliveryDate", desc: true }] });

  const [dateRange, setDateRange] = useState<Value>(null);

  const { driver, deliveries, allPagesDeliveries, meta, isLoading, refetch } =
    useGetDeliveriesByDriver({
      driverId: String(driverId),
      search: debouncedSearch,
      from:
        Array.isArray(dateRange) && dateRange[0]
          ? moment(dateRange[0]).format("YYYY-MM-DD")
          : moment().subtract(10, "year").format("YYYY-MM-DD"),
      to:
        Array.isArray(dateRange) && dateRange[1]
          ? moment(dateRange[1]).format("YYYY-MM-DD")
          : moment().add(1, "year").format("YYYY-MM-DD"),
      page,
      take: GET_LIST_REQUEST_DEFAULT_LIMIT,
      orderBy: sorting[0]?.id,
      order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "DESC"
    });

  return {
    searchValue,
    setSearchValue,
    page,
    setPage,
    sorting,
    setSorting,
    dateRange,
    setDateRange,
    driver,
    deliveries,
    allPagesDeliveries,
    isLoading,
    refetch,
    totalItems: meta?.itemCount
  };
};

export default useDeliveriesByDriver;
